<template>
  <div class="billing-history">
    <p class="dashboard__tab-sub-title">
      Billing History
    </p>
    <Invoice
      v-for="invoice in pages[currentPageNo]"
      :key="invoice.number"
      :invoice="invoice"
    />
    <InvoicePagination
      v-if="totalPagesNo > 1"
      :currentPage="parseInt(currentPageNo)"
      :pages="pages"
      :totalPages="parseInt(totalPagesNo)"
      @update-current-page-number="setCurrentPage"
    />
  </div>
</template>

<script>
import Invoice from './billing-history/Invoice.vue'
import InvoicePagination from './billing-history/InvoicePagination.vue'

export default {
  name: 'BillingHistory',
  components: {
    Invoice,
    InvoicePagination,
  },
  props: {
    invoices: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      currentPageNo: 1,
      totalPagesNo: 0,
      pages: {},
    }
  },
  methods: {
    createInvoicesByPages(invoices) {
      const totalPagesNo = Math.ceil(invoices.length / 5)
      const pages = {}
      let currentCount = 0
      for (let i = 1; i <= totalPagesNo; i++) {
        pages[i] = invoices.slice(currentCount, currentCount + 5)
        currentCount += 5
      }
      return { totalPagesNo, pages }
    },
    setCurrentPage(pageNum) {
      this.currentPageNo = pageNum
    },
  },
  created() {
    const { pages, totalPagesNo } = this.createInvoicesByPages(this.invoices)
    this.pages = pages
    this.totalPagesNo = totalPagesNo
  },
}
</script>

<style lang="scss">
.billing-history {
}
</style>
